import { Card, CardContent } from "@babackapp/ui/components/card";
import { OverrideRulesManager } from "@/components/override-rules";
import useTranslation from "@babackapp/translations/use-translation";

export default function ReturnApprovalCard() {
  const t = useTranslation();

  return (
    <Card className="w-full">
      <CardContent className="pt-6">
        <OverrideRulesManager
          actionType={"OVERRIDE_APPROVAL_REQUIRED"}
          title={t("overrideRules.approvalRequired.title")}
          description={t("overrideRules.approvalRequired.description")}
        />
      </CardContent>
    </Card>
  );
}
